import {StaticData} from "/src/classes/StaticData.js";

export default class ChartHelper {

  static buildDataset(chartType, queryColumns, queryResult) {
    // console.log("ChartHelper: queryResult=", queryResult, ", queryColumns=", queryColumns)

    // get index of legend
    let legendIdx = -1
    queryColumns.forEach((col, idx) => {
      if (col.chartIsLegend) legendIdx = idx
    })

    let i = 1;

    // build LEGEND labels
    let labels = queryResult.map(row => {
      return Object.values(row)[legendIdx]
    })

    let datasets = []
    queryColumns.forEach((col, idx) => {
      if (idx != legendIdx && col.name != '__key__') {
        let chartColor = this.getChartBkgrColor(col)

        if (Object.keys(chartColor).length > 0) {
          let chartData = this.buildChartDataset(queryResult, col.name)

          if (!chartData.every(col => col == null)) {
            // console.warn("col.name", col.name, chartData)
            if (!chartColor.bkgColor) chartColor.bkgColor = "red"

            let axis = this.getAxis(queryResult, col.name)

            switch (chartType) {
              case StaticData.CHART_TYPE.LINE:
                datasets.push({
                  label: col.label,
                  backgroundColor: chartColor.borderColor,
                  borderColor: chartColor.borderColor,
                  pointBackgroundColor: chartColor.borderColor,
                  data: this.getLineChartDataset(labels, chartData),
                  borderWidth: 2,
                  spanGaps: 1000 * 60 * 60 * 2,
                  stepped: axis == 'default' || axis.startsWith('li') ? false : true,
                  yAxisID: axis
                })
                break;
              case StaticData.CHART_TYPE.BAR:
                datasets.push({
                  label: col.label,
                  maxBarThickness: 180,
                  backgroundColor: chartColor.bkgColor,
                  borderColor: chartColor.borderColor,
                  borderWidth: 1,
                  data: chartData,
                  fill: false
                })
                break;
              case StaticData.CHART_TYPE.PIE:
                let piebgcolor = this.getPieChartBkgrColor(queryResult)
                datasets.push({
                  label: col.label,
                  maxBarThickness: 180,
                  backgroundColor: piebgcolor.bgcolor,
                  borderColor: piebgcolor.bgbordercolor,
                  borderWidth: 1,
                  data: chartData
                })
                break;
            }
          }
        }
      }
    })

    //console.warn("labels:", labels, ", datasets:", datasets)
    return {labels, datasets}
  }

  static getAxis(queryResult, colname) {
    let result = 'default'
    if (queryResult && queryResult.length > 0 && queryResult[0][colname] && queryResult[0][colname].indexOf("::") != -1) {
      result = queryResult[0][colname].split('::')[0]
    }
    return result
  }

  static getLineChartDataset(labels, chartData){
    let result = []
    if(labels.length == chartData.length){
      for(let i = 0; i < chartData.length; i++){
        if(chartData[i] != null){
          result.push({x: labels[i], y: chartData[i]})
        }
      }
    }
    return result
  }

  static getChartBkgrColor(queryColumn) {
    //let charColor = {bkgColor: this.getRandomColor(), borderColor: ""}
    let charColor = {}

    switch (queryColumn.chartColor) {
      case 1:
        charColor.bkgColor = "#FFE0E6"; // red
        charColor.borderColor = "#ED1C24";
        break;
      case 2:
        charColor.bkgColor = "#DBF2F2"; // green
        charColor.borderColor = "#22B14C";
        break;
      case 3:
        charColor.bkgColor = "#D7ECFB"; // blue
        charColor.borderColor = "#3F48CC";
        break;
      case 4:
        charColor.bkgColor = "#FFF5DD"; // yellow
        charColor.borderColor = "#FFF200";
        break;
      case 5:
        charColor.bkgColor = "#FFBF95"; // orange
        charColor.borderColor = "#FF7F27";
        break;
      case 6:
        charColor.bkgColor = "#A1A1A1"; // grey
        charColor.borderColor = "#7F7F7F";
        break;
      case 7:
        charColor.bkgColor = "#FFC7DA"; // pink
        charColor.borderColor = "#FF2971";
        break;
      case 8:
        charColor.bkgColor = "#242424"; // black
        charColor.borderColor = "#000000";
        break;
      case 9:
        charColor.bkgColor = "#DAD4EF"; // rose
        charColor.borderColor = "#C8BFE7";
        break;
      case 11:
        charColor.bkgColor = "#CEC7B0"; // beige
        charColor.borderColor = "#beb596";
        break;
      case 12:
        charColor.bkgColor = "#F2F2F2"; // light grey
        charColor.borderColor = "#E8E8E8";
        break;
      case 13:
        charColor.bkgColor = "#9A9A9A"; // dark grey
        charColor.borderColor = "#7F7F7F";
        break;
      case 14:
        charColor.bkgColor = "#242424"; // black
        charColor.borderColor = "#000000";
        break;
      case 15:
        charColor.bkgColor = "#9AE1FF"; // light blue
        charColor.borderColor = "#00A2E8";
        break;
      case 16:
        charColor.bkgColor = "#6D76D8"; // dark blue
        charColor.borderColor = "#2C34A3";
        break;
      case 17:
        charColor.bkgColor = "#E0DCF3"; // rose bright
        charColor.borderColor = "#8A7CD2";
        break;
      case 18:
        charColor.bkgColor = "#8A7CD2"; // rose dark
        charColor.borderColor = "#E0DCF3";
        break;
      case 19:
        charColor.bkgColor = "#FFD2B3"; // orange bright
        charColor.borderColor = "#D15600";
        break;
      case 20:
        charColor.bkgColor = "#D15600"; // orange dark
        charColor.borderColor = "#FFD2B3";
        break;
      case 21:
        charColor.bkgColor = "#96EAAF"; // green bright
        charColor.borderColor = "#14642B";
        break;
      case 22:
        charColor.bkgColor = "#14642B"; // green dark
        charColor.borderColor = "#96EAAF";
        break;
    }

    return charColor;
  }

  static getPieChartBkgrColor(queryResult) {
    let result = {
      bgcolor: ['#9AE1FF', '#DBF2F2', '#FFF5DD', '#FFE0E6', '#D7ECFB', '#DAD4EF', '#CEC7B0', '#F2F2F2'],
      bgbordercolor: ['#00A2E8', '#6CBEBF', '#F8CE6B', '#ED6E85', '#3F48CC', '#C8BFE7', '#beb596', '#A1A1A1']
    }
    try {
      if (queryResult && queryResult.length > 0) {
        let mybgcolor = []
        let mybgbordercolor = []
        queryResult.forEach(row => {
          if (row["bgcolor"]) {
            mybgcolor.push(JSON.parse(row["bgcolor"])[0])
            mybgbordercolor.push(JSON.parse(row["bgcolor"])[1])
          }
        })
        if (mybgcolor.length > 0) result.bgcolor = mybgcolor
        if (mybgbordercolor.length > 0) result.bgbordercolor = mybgbordercolor
      }
    } catch (err) {
      console.error("ChartHelper getPieChartBkgrColor:", err)
    }
    return result
  }

  static buildChartDataset(queryResult, name) {
    let result = queryResult.map(row => {
      let value = row[name]
      if (value) {
        value = value.replace(",", ".")
        if (value.indexOf("::") != -1) value = value.split('::')[1]
        if (value == '') value = null
      }
      return value
    })

    //console.log("result: ", result, ", after:", result.filter(val=>val!=null))
    return result
  }

  static getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 3; i++) {
      color += "C" + letters[Math.floor(Math.random() * 16)];
    }
    //console.log("random color:", color)
    return color;
  }
}
